const Modal = {
    baseStyle: () => ({
        body: {
            bg: 'white',
            borderWidth: 0,
            color: 'neutral.900',
        },
        footer: {
            bg: 'white',
            borderWidth: 0,
            bottom: 'unset',
            color: 'neutral.900',
            display: 'flex',
            height: 'unset',
            left: 'unset',
            position: 'relative',
            right: 'unset',
            top: 'unset',
            width: 'unset',
        },
        header: {
            bg: 'white',
            borderWidth: 0,
            bottom: 'unset',
            color: 'neutral.900',
            display: 'block',
            height: 'unset',
            left: 'unset',
            position: 'relative',
            right: 'unset',
            top: 'unset',
            width: 'unset',
            zIndex: 0,
        },
    }),
};
export default Modal;
